// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3xSoV","header":"Messages_header__2jl3D"};